import { Button, Form, message, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import ExpenseTypeForm from "./depensetype-Form";
import useExpenseTypes from "hooks/useExpenseTypes";

const NewExpenseTypeModal = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType } = useSelector((state) => state.modals);
  const { addExpenseType, isLoading, error, setError } = useExpenseTypes();
  const [isSendForAdd, setIsSendForAdd] = useState(false);

  useEffect(() => {
    if (isSendForAdd) {
      if (error) {
        notification.error({
          message: t("expenseTypes.crud.form.error.add"),
          description: error,
          role: "alert",
          duration: 3,
        });
      } else {
        message.success(t("expenseTypes.crud.form.add.success"));
        onClose();
      }
      setIsSendForAdd(false);
    }
  }, [isSendForAdd, error]);

  const open = isModalOpen && modalType === "new_expense_type";

  const onSubmit = async (values) => {
    setError(null);
    setIsSendForAdd(false);
    try {
      await addExpenseType(values);
    } catch (error) {
      console.error("Add expense type error:", error);
    } finally {
      setIsSendForAdd(true);
    }
  };

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={
        <h4 style={{
          textAlign: "center",
          fontSize: "20px",
          fontWeight: "bold",
          color: "#333",
          marginBottom: 0
        }}>
          {t("expenseTypes.crud.form.title")}
        </h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <div 
          key="footer-buttons" 
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            padding: "12px 0",
          }}
        >
          <Button 
            key="cancel" 
            onClick={onClose} 
            className="custom-btn-1"
            style={{
              maxWidth: "100%",
              backgroundColor: "#f5f5f5",
              color: "#555",
              borderRadius: "50px",
              padding: "12px 24px",
              border: "1px solid #ddd",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "120px",
              textAlign: "center",
              transition: "all 0.3s ease-in-out",
            }}
          >
            {t("common.cancel")}
          </Button>
          <Button
            key="submit"
            type="primary"
            htmlType="submit"
            form="depensetype-Form"
            disabled={isLoading}
            className="custom-btn-2"
            style={{
              borderRadius: "50px",
              padding: "12px 24px",
              border: "none",
              backgroundColor: "#1890ff",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "120px",
              textAlign: "center",
              transition: "all 0.3s ease-in-out",
              fontWeight: "bold"
            }}
          >
            {t("common.save")}
          </Button>
        </div>
      ]}
      centered={true} 
      styles={{ 
        content: { 
          overflowY: "auto", 
          maxHeight: "75vh",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          backgroundColor: "rgba(255, 255, 255, 0.95)"
        } 
      }}
    >
      <ExpenseTypeForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default NewExpenseTypeModal;